<template>
  <ButtonSimple
    class="theme-switcher"
    :model="appStore.configuration?.components.header.buttonSimple"
    :alt="t('header.switchDisplayModeButton.alt')"
    :text="
      appStore.currentMode() === DisplayMode.Light
        ? t('header.switchDisplayModeButton.darkThemeText')
        : t('header.switchDisplayModeButton.lightThemeText')
    "
    :click="handleSwitchDisplayModeButtonClick"
    :isDisabled="false"
    :show="true"
  >
  </ButtonSimple>
</template>

<script setup lang="ts">
import { DisplayMode } from '../types/app/displayMode'
import { useAppStore } from '../stores/appStore'
import { t } from '../composables/Translation'
import ButtonSimple from './ButtonSimple.vue'

const appStore = useAppStore()

function handleSwitchDisplayModeButtonClick(): void {
  document
    .getElementsByTagName('html')[0]
    .setAttribute(
      'data-theme',
      appStore.currentMode() === DisplayMode.Light ? DisplayMode.Dark : DisplayMode.Light
    )
  console.log('Switch Display Mode button click')
  appStore.switchMode()
}
</script>

<style scoped lang="scss">
.theme-switcher {
  min-width: 85px;
}
</style>
